<template>
    
    <div class="fadein">
        <div class="h30"></div>
        <div class="center1000">

            <el-tabs type="border-card" tab-position="left" class="tab" v-model="activeName">
                <!-- 信息主页 Start -->
                <el-tab-pane name="summary">
                    <div class="slot" slot="label">
                        <i class="el-icon-setting"></i> 信息主页
                    </div>
                  <div class="summary">
                      <a href="javascript:;" @click="chooseUserpic()">
                        <el-tooltip class="item" effect="dark" content="编辑头像" placement="top">
                        <img :src="userinfo.user_pic" alt="" class="user-pic">
                    </el-tooltip>
                        </a>
                    <div class="nickname">
                        <el-tooltip class="item" effect="dark" content="编辑昵称 签名" placement="top">
                        <span>

                        <a href="javascript:;" @click="chooseEdit()"  v-if="userinfo.nickname">
                            {{userinfo.nickname}}
                        </a>
                        <!-- <a href="javascript:;" @click="chooseEdit()"  v-else-if="userinfo.username">
                            {{userinfo.username}}
                        </a> -->
                        <a href="javascript:;" @click="chooseEdit()"  v-else="userinfo.nickname">
                             {{userinfo.mobile}}
                        </a>
                        <img style="vertical-align: middle;" src="/static/img/lv/LV0.png" alt="" v-if="userinfo.level==0"><img style="vertical-align: middle;" src="/static/img/lv/LV1.png" alt="" v-if="userinfo.level==1"><img style="vertical-align: middle;" src="/static/img/lv/LV2.png" alt="" v-if="userinfo.level==2"><img style="vertical-align: middle;" src="/static/img/lv/LV3.png" alt="" v-if="userinfo.level==3"><img style="vertical-align: middle;" src="/static/img/lv/LV4.png" alt="" v-if="userinfo.level==4"><img style="vertical-align: middle;" src="/static/img/lv/LV5.png" alt="" v-if="userinfo.level==5">
                        <router-link to="/test" style="font-size:16px;" v-if="userinfo.level==0">升级</router-link>
                        </span>
                    </el-tooltip>
                    <div v-if="userinfo.signature" class="signature">{{userinfo.signature}}</div>
                    <div v-else class="signature">系统原装签名，献给每一位小可爱</div>
                    </div>
                    <!-- <div v-else class="nickname">路人甲</div> -->
                    
                    <el-progress :text-inside="true" :stroke-width="26" :percentage="80" style="width:400px;"></el-progress>
                    <div style="clear:both"></div>
                    <div class="h20"></div>
                    <div v-if="getusername">用户名：{{getusername}}</div>
                    <div v-else>用户名：-</div>
                    <div class="h20"></div>
                    <div>手机绑定：{{userinfo.mobile}}</div>
                    
                    <div class="h20"></div>
                    <div>性别：{{userinfo.sex}}</div>
                    <!-- <div>user_pic</div> -->

                    <div class="h20"></div>

                    <div v-if="userinfo.email">绑定邮箱：{{userinfo.email}}</div>
                    <div v-else>绑定邮箱：-</div>

                    <div class="h20"></div>
                    <el-button type="primary" @click="chooseEdit()">编辑信息</el-button>
                  </div>
                </el-tab-pane>
                <!-- 信息主页 End -->
                <!-- 头像修改 Start -->
                <el-tab-pane name="userpic">
                    <div class="slot" slot="label">
                        <i class="el-icon-user"></i> 头像修改
                    </div>
                    <div class="userpic">

                  <div>支持jpg格式，大小不超过2M</div>
                  <Clip></Clip>

                </div>
                </el-tab-pane>
                <!-- 头像修改 End -->
                <!-- 信息修改 Start -->
                <el-tab-pane name="edit">
                    <div class="slot" slot="label">
                        <i class="el-icon-edit"></i> 信息修改
                    </div>
                  <div class="edit">
                      <!-- <div class="center-title">- 信息修改 -</div> -->
                      <div class="h30"></div>
                    <el-form ref="form" :model="form" label-width="100px">
                        <el-form-item label="昵称">
                          <el-input v-model="form.nickname" style="width:400px;"></el-input>
                        </el-form-item>
                       
                        
                        <el-form-item label="性别">
                          <el-radio-group v-model="form.sex">
                            <el-radio label="男"></el-radio>
                            <el-radio label="女"></el-radio>
                          </el-radio-group>
                        </el-form-item>

                        <el-form-item label="签名">
                          <el-input type="textarea" v-model="form.signature" style="width:400px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" @click="onSubmit">修改信息</el-button>
                        </el-form-item>
                      </el-form>
                  </div>

                </el-tab-pane>
                <!-- 信息修改 End -->
                <!-- 修改密码 Start -->
                <el-tab-pane>
                    <div class="h30"></div>
                    <div class="slot" slot="label">
                        <i class="el-icon-lock"></i> 修改密码
                    </div>
                    <div class="password">
                        <el-form ref="passform" :model="passform" label-width="100px">
                            <el-form-item label="原始密码">
                                <el-input type="password" v-model="passform.ori_password" style="width:400px;"></el-input>
                            </el-form-item>
                            <el-form-item label="新密码">
                                <el-input type="password" v-model="passform.password" autocomplete="off" style="width:400px;"></el-input>
                            </el-form-item>
                            <el-form-item label="确认密码">
                                <el-input type="password" v-model="passform.password_confirmation" autocomplete="off" style="width:400px;"></el-input>
                            </el-form-item>
                            <el-form-item>

                                <el-button type="primary" @click="changePass">修改密码</el-button>
                            </el-form-item>
                        </el-form>
                        
                    </div>
                </el-tab-pane>
                <!-- 修改密码 End -->
                <!-- 绑定邮箱 Start -->
                <el-tab-pane>
                <div class="h30"></div>
                <div class="slot" slot="label">
                <i class="el-icon-message"></i> 绑定邮箱
                </div>
                <div class="email">
                    <el-form label-width="100px">
                        <el-form-item label="绑定邮箱">
                            <el-input type="text" v-model="email" style="width:400px;"></el-input>
                        </el-form-item>
                        <el-form-item>

                            <el-button type="primary" @click="bindEmail">绑定邮箱</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                </el-tab-pane>
                <!-- 绑定邮箱 End -->
                <!-- 绑定用户名 Start -->
                <el-tab-pane>
                <div class="h30"></div>
                <div class="slot" slot="label">
                    <i class="el-icon-warning-outline"></i> 绑定用户名
                </div>
                <div class="username">
                    <el-form label-width="100px">
                        <el-form-item label="绑定用户名">
                            <el-input type="text" v-model="username" style="width:400px;" v-if='getusername==null'></el-input>
                            <el-input type="text" v-model="getusername" style="width:400px;" v-else disabled></el-input>
                        </el-form-item>
                        <el-alert
                        title="* 注意，用户名可用于登录，只能绑定一次，不可修改"
                        type="warning"
                        show-icon>
                        </el-alert>
                        <div class="h20"></div>
                        <el-form-item v-if="getusername==null">
                            <el-tooltip class="item" effect="dark" content="* 注意，用户名可用于登录，只能绑定一次，不可修改" placement="right">
                                <el-popconfirm
                                confirmButtonType="warning"
                                confirmButtonText='是'
                                cancelButtonText='再想想'
                                icon="el-icon-info"
                                iconColor="#009999"
                                cancelButtonTextColor="#009999"
                                title="* 确认绑定，不可修改"
                                @onConfirm="bindUsername()"
                                >
                                <el-button slot="reference" type="warning" >绑定用户名</el-button>
                                </el-popconfirm>
                                
                            </el-tooltip>
                        </el-form-item>
                    </el-form>
                </div>
                </el-tab-pane>
                <!-- 绑定用户名 End -->
              </el-tabs>

        </div>
        <Goback></Goback>
        <div class="h30"></div>
    </div>
</template>
<style scoped>
.tab{
    height:800px;
}
.summary {
    padding:50px;
}

.summary .user-pic{
    width:100px;
    border-radius: 50%;
    border-radius:50% !important;
    vertical-align: middle;
    border:1px solid #ccc;
    float: left;
    margin-right:15px;
    margin-bottom:20px;
}
.nickname{
    font-size:22px;
    padding-top:30px;
    line-height:30px;
    font-weight:800;
}
.signature{
    font-size:16px;
    color:#999;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-top:10px;
    line-height: 20px;
    font-weight:500;
}
.center1000{
    width:1000px;
    margin:0 auto;
}
a{
    color:#303133;
    text-decoration: none;
    transition: 0.5s;
}
a:hover{
    color:#ff7400;
    transition: 0.5s;
}
.userpic{
    padding:50px;
}
/* 头像上传 */
 .el-upload {
    border: 2px dashed #ccc;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.el-upload:hover {
    border-color: #ff7400;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .slot{
    width:90px;
    text-align:left;
  }
</style>
<script>
     import Goback from '@/components/components/goback'
    import Clip from '@/components/components/clip'
    export default{

        data(){
            return {
                // 用户id
                id: 0,
                // Tab标签的根据name选择
                activeName: 'summary',
                // 表单提交数据
                form:{
                    nickname:'',
                    sex:'',
                    signature:'',
                    _method: "put"
                },
                // 修改密码
                passform:{
                    ori_password:'',
                    password:'',
                    password_confirmation:'',
                    _method:"put"
                },
                // 用户信息
                userinfo : {
                    nickname:'',
                },
                //原始头像
                user_pic:'',
                // 头像上传
                imageUrl: '',
                uploadUrl:'//'+ this.$API_URL +'/api/v1/add_user_pic/'+this.id,
                dialogVisible:false,
                // 邮箱绑定
                email:'',
                // 用户名绑定
                username:'',
                // 用户名回显
                getusername:'',
            }
        },
        async mounted(){
            if(localStorage.getItem('token')==null){
                this.$message({
                    showClose:true,
                    message:"请先登录~",
                    type:"error"
                })
                this.$router.push('/login').catch(err => {err});
            }
            await this.getUserinfo();
        },
        methods:{
            //获取用户信息
            getUserinfo(){
                this.id = localStorage.getItem('token');
                console.log(this.id)
                $.ajax({
                    url:'//'+ this.$API_URL +'/api/v1/user_info/'+this.id,
                    type:'get',
                    timeout:3000,
                    success:(ret)=>{
                        // 

                        this.userinfo=ret.data
                        this.form.nickname = ret.data.nickname
                        this.form.sex = ret.data.sex
                        this.form.signature = ret.data.signature
                        this.email = ret.data.email
                        this.getusername = ret.data.username
                        // 
                        // if(ret.data.user_pic == "http://'+ this.$API_URL +'"){
                        if(ret.data.user_pic == "http://" + this.$API_URL){
                            this.userinfo.user_pic = '/static/img/default_userpic.png'
                        }
                        // console.log(222)
                    }
                })
            },
            
            chooseSummary(){
                this.activeName="summary";
            },
            // 跳转到修改信息Tab
            chooseEdit() {
                this.activeName="edit";
            },
            // 跳转到头像上传Tab
            chooseUserpic() {
                this.activeName="userpic";
            },
            // 用户修改信息提交
            onSubmit(){
                if(this.form.nickname == ''){
                    this.$message({
                        showClose:true,
                        message:'昵称不能为空',
                        type:"error"
                    })
                    return false;
                }
                // 
                var id = localStorage.getItem('token');
                $.ajax({
                    url:'//'+ this.$API_URL +'/api/v1/fill_user_info/'+id,
                    data:this.form,
                    type:'POST',
                    timeout:3000,
                    success:ret=>{
                        
                        
                        if(ret.code==201){
                            this.$message({
                                showClose: true,
                                message: ret.msg,
                                type: 'success'
                            });

                        }else{
                            this.$message({
                                showClose: true,
                                message: ret.msg,
                                type: 'error'
                            });
                        }
                    this.$parent.username = this.form.nickname

                    },
                    error:ret=>{
                        
                        
                    },
                })

            },
                        
            // 头像上传
            handleAvatarSuccess(res, file) {
                this.$refs.upload.clearFiles();
                this.$refs.upload.uploadFiles.push(file);
                this.imageUrl = file.url;

                this.imageUrl = URL.createObjectURL(file.raw);
                
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },

            //修改密码
            changePass(){
                                // 确认密码的判断
                if(this.passform.password != this.passform.password_confirmation){
                    this.$message({
                        showClose: true,
                        message: '两次设置的密码不一致 :<',
                        type: 'error'
                    });
                    return false;
                }

                if(this.passform.ori_password.length<6){
                    this.$message({
                        showClose: true,
                        message: '原始密码的最小长度为6位 :<',
                        type: 'error'
                    });
                    return false;
                }

                if(this.passform.password.length<6){
                    this.$message({
                        showClose: true,
                        message: '新密码的最小长度为6位 :<',
                        type: 'error'
                    });
                    return false;
                }
                // 
                $.ajax({
                    url:'//'+ this.$API_URL +'/api/v1/changePassword/'+this.id,
                    type:'post',
                    data:this.passform,
                    success:(ret)=>{
                        if(ret.code==201){
                            // 
                            this.$message({
                                showClose: true,
                                message: ret.msg,
                                type: 'success'
                            });
                        }else{
                            this.$message({
                                showClose: true,
                                message: ret.msg,
                                type: 'error'
                            });
                        }
                        
                    },
                    error:(ret)=>{
                        
                    }
                })
            },
        
            //绑定邮箱
            bindEmail(){
                //邮箱正则
                if(!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))){
                    this.$message({
                        showClose: true,
                        message: "邮箱格式不对呀 :<",
                        type: 'error'
                    });
                    return false;
                }
                $.ajax({
                    url:'//'+ this.$API_URL +'/api/v1/fill_email/'+this.id,
                    type:'post',
                    data:{email:this.email},
                    success:(ret)=>{
                        if(ret.code==201){
                            this.$message({
                                showClose: true,
                                message: ret.msg,
                                type: 'success'
                            });
                            this.getUserinfo();
                            this.chooseSummary();
                        }else{
                            this.$message({
                                showClose: true,
                                message: "这个邮箱已经被绑过了呀 :<",
                                type: 'error'
                            });
                            this.getUserinfo();
                        }
                    },
                    error:(ret)=>{
                        this.$message({
                            showClose: true,
                            message: "内部错误 :<",
                            type: 'error'
                        });
                    }
                })
                this.getUserinfo();
            },

            //绑定用户名
            bindUsername(){
                
                if(!(/^[a-zA-Z]/).test(this.username)){
                    this.$message({
                        showClose: true,
                        message: '用户名必须以字母开头',
                        type: 'error'
                    })
                    return false;
                }
                if(this.username.length<6){
                    this.$message({
                        showClose: true,
                        message: '用户名的长度至少为6',
                        type: 'error'
                    })
                    return false;
                }
                $.ajax({
                    url:'//'+ this.$API_URL +'/api/v1/fill_username/'+this.id,
                    type:'post',
                    data:{username:this.username},
                    success:(ret)=>{
                        if(ret.code==201){
                            this.$message({
                                showClose: true,
                                message: ret.msg,
                                type: 'success'
                            })
                            this.getusername = this.username
                            // this.getUserinfo();
                            // this.chooseSummary();
                            location.reload();
                        }else{
                            
                            $.each(ret.data.username,(k,v)=>{
                                // 
                                setTimeout(()=>{
                                    this.$message({
                                        showClose: true,
                                        message: v,
                                        type: 'error'
                                    })
                                },50)
                            })
                            return false;
                        }
                    }
                })

                
            }
        
        },
        
        components:{
            Clip,            Goback,
        }
    }
    
</script>



// WEBPACK FOOTER //
// src/components/index/account.vue